"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === _configConstants.CONFIG_ROOT_FOUND) {
    return _extends({}, state, {
      rootDir: action.rootDir
    });
  }

  if (action.type === _configConstants.CONFIG_VERSION) {
    return _extends({}, state, {
      version: action.version
    });
  }

  if (action.type === _configConstants.CONFIG_LOADED) {
    return _extends({}, state, action.configData);
  }

  if (action.type === _configConstants.CONFIG_PACKAGE_FOUND) {
    return _extends({}, state, {
      packageDirs: [].concat(_toConsumableArray(state.packageDirs), [action.dir])
    });
  }

  return state;
};

var _configConstants = require("./configConstants");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  port: 3333,
  packageDirs: [],
  openBrowserOnStartup: false
};
//# sourceMappingURL=configReducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/config/configReducer.js
// module id = 243
// module chunks = 0